const dinner = [
    {
        id: 1,
        name: 'Chicken Curry Set : チキンカレーセット',
        description: 'Spiced chicken curry served with fresh naan and side salad',
        price: '¥950'
    },
    {
        id: 2,
        name: 'Butter Chicken Curry Set : バターチキンカレーセット',
        description: 'Creamy tomato-based butter chicken served with naan and side salad',
        price: '¥1,000'
    },
    {
        id: 3,
        name: 'Dal Tadka Set : ダールタルカセット',
        description: 'Yellow lentils tempered with garlic and spices, served with naan and side salad',
        price: '¥900'
    },
    {
        id: 4,
        name: 'Tandoori Chicken(1pcs) Set : タンドリーチキン（1本）セット',
        description: 'Juicy tandoori chicken served with naan and side salad',
        price: '¥1,200'
    },
    {
        id: 5,
        name: 'Mutton Curry Set : マトンカレーセット',
        description: 'Tender mutton curry served with naan and side salad',
        price: '¥1,000'
    },
    {
        id: 6,
        name: 'Keema Curry Set : キーマカレーセット',
        description: 'Spiced minced meat curry served with naan and side salad',
        price: '¥1,000'
    },
    {
        id: 7,
        name: 'Vegetable Curry Set : ベジタブルカレーセット',
        description: 'Seasonal vegetable curry served with naan and side salad',
        price: '¥850'
    },
    {
        id: 8,
        name: 'Chicken Tikka(2pcs) Set : チキンティッカ（2個）セット',
        description: 'Grilled chicken tikka pieces served with naan and side salad',
        price: '¥1,199'
    },
    {
        id: 9,
        description: '   All curries are available spiciness choice.',
        price: 'Mild   --  Medium  --   Hot'
    }
];

export default dinner;